import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function Calendar(props) {
  const blue = getColorValue('illustrationAccent');
  const orange = getColorValue('illustrationOrange');
  const line = getColorValue('illustrationLine');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m217.84 60.1699-10.45 161.0201h25.43l-7.18-161.0201z"
        fill={blue}
      />
      <path
        d="m51.45 60.1699-10.45 161.0201h180.21l5.53-161.0201z"
        fill={orange}
      />
      <path
        d="m226.75 60.1699h-8.91l-10.45 161.0201h13.82l5.05-147.0201z"
        fill={getColorValue('tealDark')}
      />
      <path d="m233.76 54h-191.51v37.17h191.51z" fill={orange} />
      <path
        d="m49.43 91.1699h176.25l1.06-31h-175.29z"
        fill={illustrationColors.staticRed}
      />
      <g fill={line}>
        <path d="m77.9198 110.658c.04-2.4-1.07-2.47-1.35-.09-.38 3.37-.7 6.93-1.01 11.5-.28 5.19-.14 6.49-.39 10-.38 5.93-1.34 15.92-1.58 18.33-.03.36-.06.71-.08 1.07-.12 2.56-.68 13.77-1.39 23.42-.44 6.81-.71 11.03-.85 13.24-.33 5.2-.47 9.1-.5 12.93-.02 2.1.95 2.17 1.2.08.46-3.8.83-7.68 1.17-12.89.13-2.02.67-6.22 1.1-12.16.07-.97.11-1.94.14-2.9.18-8.31.98-19.07.98-19.07s1.05-16.06 1.49-22.84c.33-5.11.49-7.56.58-9.07.29-4.57.43-8.13.49-11.53z" />
        <path d="m129.17 110.658c.04-2.4-1.07-2.47-1.35-.09-.38 3.37-.7 6.93-1.01 11.5-.28 5.19-.14 6.49-.39 10-.38 5.93-1.34 15.92-1.58 18.33-.03.36-.06.71-.08 1.07-.12 2.56-.68 13.77-1.39 23.42-.44 6.81-.71 11.03-.85 13.24-.33 5.2-.47 9.1-.5 12.93-.02 2.1.95 2.17 1.2.08.46-3.8.83-7.68 1.17-12.89.13-2.02.67-6.22 1.1-12.16.07-.97.11-1.94.14-2.9.18-8.31.98-19.07.98-19.07s1.05-16.06 1.49-22.84c.33-5.11.49-7.56.58-9.07.29-4.57.43-8.13.49-11.53z" />
        <path d="m180.42 110.658c.04-2.4-1.07-2.47-1.35-.09-.38 3.37-.7 6.93-1.01 11.5-.28 5.19-.14 6.49-.39 10-.38 5.93-1.34 15.92-1.58 18.33-.03.36-.06.71-.08 1.07-.12 2.56-.68 13.77-1.39 23.42-.44 6.81-.71 11.03-.85 13.24-.33 5.2-.47 9.1-.5 12.93-.02 2.1.95 2.17 1.2.08.46-3.8.83-7.68 1.17-12.89.13-2.02.67-6.22 1.1-12.16.07-.97.11-1.94.14-2.9.18-8.31.98-19.07.98-19.07s1.05-16.06 1.49-22.84c.33-5.11.49-7.56.58-9.07.29-4.57.43-8.13.49-11.53z" />
        <path d="m202.23 125.409c3.73-.1 3.74-1.22 0-1.35-5.29-.18-10.85-.29-17.99-.32-8.1.03-10.12.25-15.6.21-9.27-.03-24.91-.39-28.68-.48-.56-.01-1.11-.02-1.67-.01-3.99.03-21.51.14-36.59.01-10.6501-.03-17.2401-.05-20.6901-.06-8.13-.02-14.21.08-20.17.27-3.28.11-3.28 1.08 0 1.2 5.96.23 12.04.37 20.17.4 3.16.01 9.74.3 19.0401.38 1.51.01 3.03 0 4.53-.04 12.96-.32 29.79-.16 29.79-.16s25.11.09 35.7.12c7.98.02 11.82.03 14.18.04 7.15.02 12.7-.05 18-.2z" />
        <path d="m202.23 167.938c3.73-.1 3.74-1.22 0-1.35-5.29-.18-10.85-.29-17.99-.32-8.1.03-10.12.25-15.6.21-9.27-.03-24.91-.39-28.68-.48-.56-.01-1.11-.02-1.67-.01-3.99.03-21.51.14-36.59.01-10.6501-.03-17.2401-.05-20.6901-.06-8.13-.02-14.21.08-20.17.27-3.28.11-3.28 1.08 0 1.2 5.96.23 12.04.37 20.17.4 3.16.01 9.74.3 19.0401.38 1.51.01 3.03 0 4.53-.04 12.96-.32 29.79-.16 29.79-.16s25.11.09 35.7.12c7.98.02 11.82.03 14.18.04 7.15.02 12.7-.05 18-.2z" />
      </g>
    </svg>
  );
}

export default Calendar;
